import api from '@/lib/axios'

export interface LocalizedString {
    tr: string
    en?: string
    fr?: string
    es?: string
    ru?: string
    nl?: string
    ar?: string
}

export interface EngineeringFeature {
    icon: string
    text: LocalizedString
}

export interface EngineeringSoftware {
    icon: string
    name: string
    details: LocalizedString
}

export interface EngineeringData {
    badge: LocalizedString
    title1: LocalizedString
    title2: LocalizedString
    body: LocalizedString
    advancedTitle: LocalizedString
    advancedBody: LocalizedString
    features: EngineeringFeature[]
    softwares: EngineeringSoftware[]
}

export const engineeringService = {
    getEngineering: async (): Promise<EngineeringData> => {
        const response = await api.get('/engineering/raw')
        return response.data
    },

    updateEngineering: async (data: Partial<EngineeringData>): Promise<EngineeringData> => {
        const response = await api.put('/engineering', data)
        return response.data
    },
}
